import { ButtonTertiary } from "@nova/component-btn"
import { ScrollableArea } from "@nova/component-scrollable-area"
import { InputOutlined } from "@nova/ds-component-input"
import classNames from "classnames"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"
import { useRouter } from "pages"
import { useState, useMemo } from "react"
import { useParams } from "react-router"
import { usePilots } from "./PilotQueries"
import * as Icons from "@nova/component-icons"
import { BetaTag } from "features/BetaTag"

export const PilotTrackingPilotNestedSidebar = () => {
    const { pilotId = "" } = useParams()
    const router = useRouter("/workspace/:workspaceId")
    const [search, setSearch] = useState("")
    const [sort, setSort] = useState<"asc" | "desc">("asc")
    const { pilots } = usePilots({ search })
    const sortedPilots = useMemo(() => {
        return pilots?.toSorted(
            (a, b) => (a.fullName || "").localeCompare(b.fullName || "") * (sort === "asc" ? 1 : -1)
        )
    }, [pilots, sort])
    return (
        <div className="w-[240px] min-w-[240px] border-r border-r-gray-700 px-3 py-5 flex flex-col gap-2">
            <div className="flex items-center gap-3 py-2">
                <router.Link to={{ path: "/fleet/pilots" }}>
                    <Icons.SmallIcon
                        Icon={Icons.ArrowLeft}
                        className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                    />
                </router.Link>
                <div className="text-[1.375rem] telegraf">Pilots</div>
                <BetaTag />
            </div>
            <div className="flex items-center gap-1">
                <div className="shrink min-w-0">
                    <InputOutlined
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        placeholder="Search"
                        leftItem={<Icons.Icon Icon={Icons.MagnifyingGlass} />}
                    />
                </div>
                <ButtonTertiary
                    RightIcon={sort === "desc" ? Icons.SortByAlphaDesc : Icons.SortByAlphaAsc}
                    className="!px-3 h-full !min-w-0"
                    rightIconClassName={classNames({
                        "pb-1": sort === "desc",
                        "pt-1": sort === "asc",
                    })}
                    onClick={() => setSort((v) => (v === "asc" ? "desc" : "asc"))}
                />
            </div>
            <ScrollableArea className="grow">
                <div className="flex flex-col gap-1">
                    {sortedPilots?.length ? (
                        sortedPilots.map((pilot) => (
                            <router.Link
                                key={pilot.id}
                                to={{
                                    path: "/fleet/pilots/:pilotId",
                                    params: { pilotId: pilot.id || "" },
                                }}
                            >
                                <div
                                    className={classNames(
                                        "p-1.5 rounded-lg cursor-pointer flex gap-3 items-center",
                                        {
                                            "hover:bg-white-100": pilotId !== pilot.id,
                                            "bg-white-200": pilotId === pilot.id,
                                        }
                                    )}
                                >
                                    <div className="w-8 aspect-square rounded-md overflow-hidden">
                                        <ProfilePhoto
                                            userId={pilot.id || ""}
                                            fullName={pilot.fullName || ""}
                                        />
                                    </div>
                                    <div className="truncate">{pilot.fullName}</div>
                                </div>
                            </router.Link>
                        ))
                    ) : (
                        <div className="flex flex-col gap-2 items-center justify-center py-8">
                            <div className="text-white">No Pilots Found</div>
                            <div className="text-xs text-gray-100">Try a different keyword.</div>
                        </div>
                    )}
                </div>
            </ScrollableArea>
        </div>
    )
}
